namespace Nobox.Pages {
    export interface Base64ToFileRequest {
        media?: Web.Hubs.MessageMedia;
    }
}
